import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  isConnectedDomain,
  isMediawireDomain,
  isNonRelAttrDomain,
} from 'config/public';
import { isSingleDomainPages } from 'utils/common';
import { isAffiliate, getEncodedAffiliateLink } from 'utils/Affiliate';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { bindGa } from '../../helpers/analytics';
import {
  shouldAppendFrmApp,
  appendFrmAppToUrl,
} from '../../helpers/frmapp/frmAppLink';
// import history from '../../history';
import { TOI_LIVE_DOMAIN } from '../../constants';
import {
  getReviewURL,
  isReviewsLink,
} from '../../routes/articleshow_v2/utils/mspUtils';

// function isLeftClickEvent(event) {
//   return event.button === 0;
// }

// function isModifiedEvent(event) {
//   return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
// }

// const nonSpaLinks = [
//   '/entertainment',
//   '/tv',
//   '/life-style',
//   'lifestyle',
//   '/beauty-pageants',
// ];
// const doesLinkContainNonSpaLink = url => {
//   let spa = false;
//   if (typeof url === 'string') {
//     if (url.indexOf('videoshow') >= 0 && this.props.isMobile) {
//       return false;
//     }
//     nonSpaLinks.forEach(item => {
//       if (url.indexOf(item) >= 0) {
//         spa = true;
//       }
//     });
//   }
//   return spa;
// };

const isSpotlightLink = linkUrl =>
  linkUrl &&
  linkUrl.includes('/spotlight/') &&
  linkUrl.includes('/articleshow/');

const isSpanishLink = linkUrl =>
  linkUrl && linkUrl.includes('spanish.itimes.com');

class Link extends React.Component {
  static propTypes = {
    to: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func,
    href: PropTypes.string,
    extraClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: null,
    to: undefined,
    children: null,
    href: undefined,
    extraClick: null,
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.handleClick = this.handleClick.bind(this);
  }

  getLiveURL(url) {
    const {
      siteConfig: { affiliates: { reviewsConfig = [] } = {} } = {},
    } = this.props.commonState;
    if (isReviewsLink(reviewsConfig, url, this.props.isReviewsPage)) {
      return getReviewURL(url);
    }
    let finalURL = url;
    const domain = TOI_LIVE_DOMAIN;
    // ? TOI_LIVE_MOBILE_DOMAIN
    // : TOI_LIVE_DOMAIN;

    if (this.props.isMobile && isSingleDomainPages(url)) {
      finalURL = url
        .split('m.timesofindia.com')
        .join('timesofindia.indiatimes.com');
      if (finalURL[0] === '/') {
        finalURL = TOI_LIVE_DOMAIN + finalURL;
      }
    } else if (finalURL[0] === '/' && !this.props.route && !this.props.spa) {
      finalURL = domain + finalURL;
    } else if (
      this.props.isMobile &&
      url &&
      url.indexOf('timesofindia.indiatimes.com') > -1 &&
      url.indexOf('/liveblog/') === -1 &&
      url.indexOf('/blogs/') === -1 &&
      url.indexOf('/readersblog/') === -1 &&
      !this.props.doNotChangeDomain &&
      !this.props.doNotChangeURL
    ) {
      finalURL = url
        .split('timesofindia.indiatimes.com')
        .join('m.timesofindia.com');
    }
    return finalURL;
  }
  static getRelativeUrl(absoluteUrl) {
    if (
      typeof absoluteUrl === 'string' &&
      absoluteUrl.indexOf('https://timesofindia.indiatimes.com') >= 0
    ) {
      return absoluteUrl.replace('https://timesofindia.indiatimes.com', '');
    } else if (
      typeof absoluteUrl === 'string' &&
      absoluteUrl.startsWith('http')
    ) {
      return new URL(absoluteUrl).pathname;
    }
    return absoluteUrl || '';
  }

  @bindGa({})
  handleClick(event) {
    if (this.props.data) {
      sendGaThroughProps({ data: this.props.data });
    }
    if (this.props.ga4Data && Array.isArray(this.props.ga4Data)) {
      analyticsWrapper('ga4', ...this.props.ga4Data);
    }
    if (this.props.ext) {
      return;
    }
    // const relativeURL = Link.getRelativeUrl(this.props.to);
    //this code wont be executed as handleClick is not bound when this.props.onClick is passed as props
    if (this.props && this.props.onClick) {
      this.props.onClick(event);
      event.preventDefault();
    }
    if (this.props.extraClick) {
      this.props.extraClick();
    }

    if (this.props.isNoLink) {
      return;
    }
    // if (
    //   this.props.spa &&
    //   relativeURL.startsWith('/') &&
    //   !doesLinkContainNonSpaLink(relativeURL)
    // ) {
    //   event.preventDefault();
    //   if (shouldAppendFrmApp()) {
    //     history.push(appendFrmAppToUrl(relativeURL));
    //   } else {
    //     history.push(relativeURL);
    //   }
    //   return;
    // }
    const anchor = event.target.closest('a');
    if (!anchor) {
      return;
    }
    // eslint-disable-next-line no-unused-vars
    let newHref = anchor.href;
    if (anchor.href && !this.props.isMobile && shouldAppendFrmApp()) {
      // event.preventDefault();
      // window.location.href = appendFrmAppToUrl(newHref);
    } else if (this.props.isMobile && !this.props.disableClick) {
      // event.preventDefault();
      if (
        !this.props.doNotChangeURL &&
        !this.props.doNotChangeDomain &&
        anchor.href &&
        anchor.href.indexOf('timesofindia.indiatimes.com') > 0 &&
        anchor.href.indexOf('/liveblog/') === -1 &&
        anchor.href.indexOf('/videoshow/') === -1 &&
        anchor.href.indexOf('/photostory/') === -1 &&
        anchor.href.indexOf('/articleshow/') === -1 &&
        anchor.href.indexOf('/blogs/') === -1 &&
        anchor.href.indexOf('/readersblog/') === -1
      ) {
        newHref = newHref.replace(
          'timesofindia.indiatimes.com',
          'm.timesofindia.com',
        );
      }
      if (shouldAppendFrmApp()) {
        if (
          newHref.indexOf('.indiatimes.com') > -1 ||
          newHref.indexOf('.timesofindia.com') > -1 ||
          newHref.indexOf('.gadgetsnow.com') > -1
        ) {
          newHref = appendFrmAppToUrl(newHref);
        }
      }
      anchor.href = newHref;
      // if (anchor.getAttribute('target')) {
      //   window.open(newHref, '_blank');
      // } else {
      //   window.location.href = newHref;
      // }
    }

    // if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
    //   return;
    // }

    // if (event.defaultPrevented === true) {
    //   return;
    // }

    // event.preventDefault();
    // this.props && (location.href = this.props.to);
    // window.open(this.props.to);
  }

  render() {
    const {
      to,
      children,
      ext,
      skipAffiliateHandling,
      isNoLink,
      isReviewsPage,
      ariaLabel,
      ...props
    } = this.props;
    let linkUrl = to || (this.props.href ? this.props.href : '');
    const isAffiliateLink = !skipAffiliateHandling && isAffiliate(linkUrl);
    let nofollow = this.props.rel || 'noopener nofollow noreferrer';
    const isThisConnectedDomain = isConnectedDomain(linkUrl);
    const isThisNonRelAttrDomain = isNonRelAttrDomain(linkUrl);
    const isToiLink =
      typeof linkUrl === 'string' &&
      (linkUrl.indexOf('timesofindia.indiatimes.com') >= 0 ||
        linkUrl.indexOf('m.timesofindia.com') >= 0 ||
        linkUrl.startsWith('/'));

    if (
      isToiLink ||
      isThisConnectedDomain ||
      isThisNonRelAttrDomain ||
      isReviewsPage
    ) {
      if (isMediawireDomain(linkUrl)) {
        nofollow = 'noopener nofollow';
      } else if (this.props.target === '_blank' && !isThisNonRelAttrDomain) {
        nofollow = 'noopener';
      } else if (nofollow === 'dofollow') {
        nofollow = undefined;
      } else {
        nofollow = undefined;
      }
    }
    if (nofollow === 'dofollow') {
      nofollow = undefined;
    }

    if (isAffiliateLink) {
      const isWap = this.props.isMobile;
      const isMSP = this.props.isMspArticle;
      nofollow += ' nofollow sponsored';
      linkUrl = getEncodedAffiliateLink('', linkUrl, isWap, isMSP).replace(
        '<title>',
        '',
      );
    }
    if (this.props.rel && this.props.rel === 'sponsored noopener') {
      nofollow = 'sponsored noopener';
    }
    if (
      isSpotlightLink(linkUrl) &&
      nofollow &&
      !nofollow.includes('sponsored')
    ) {
      nofollow += ' sponsored';
    }
    if (isSpanishLink(linkUrl) && nofollow) {
      nofollow = 'dofollow';
    }

    // isToiLink - Overriding target _blank in case toilink | Due to google interstial | overriding props due to props injected on a tag
    let target = this.props?.target ? this.props?.target : '';
    if (isToiLink) {
      props.target = undefined;
      target = '';
    }

    if (this.props.forceTargetBlank) {
      // NOTE:- web interstiatial ads viewability will be affected, only enabled on MSP and hotpicks
      target = '_blank';
    }

    if (isNoLink) {
      return (
        <div {...props} className={props.className} onClick={this.handleClick}>
          {children}
        </div>
      );
    }

    if (target) {
      return (
        <a
          href={this.getLiveURL(linkUrl)}
          {...props}
          onClick={this.props.onClick || this.handleClick}
          rel={nofollow}
          // eslint-disable-next-line react/no-unknown-property
          frmappuse="1"
          data={undefined}
          ref={this.props.innerRef}
          target={target}
          aria-label={ariaLabel}
        >
          {children}
        </a>
      );
    }
    return (
      <a
        href={this.getLiveURL(linkUrl)}
        {...props}
        onClick={this.props.onClick || this.handleClick}
        rel={nofollow}
        // eslint-disable-next-line react/no-unknown-property
        frmappuse="1"
        data={undefined}
        ref={this.props.innerRef}
        aria-label={ariaLabel}
      >
        {children}
      </a>
    );
  }
}

Link.propTypes = {
  isNoLink: PropTypes.bool,
  route: PropTypes.string,
  doNotChangeURL: PropTypes.bool,
  doNotChangeDomain: PropTypes.bool,
  skipAffiliateHandling: PropTypes.bool,
  rel: PropTypes.string,
  isMobile: PropTypes.bool,
  target: PropTypes.bool,
  isMspArticle: PropTypes.bool,
  forceTargetBlank: PropTypes.bool,
  isReviewsPage: PropTypes.bool,
  commonState: PropTypes.shape({}),
};

Link.defaultProps = {
  isNoLink: false,
  route: undefined,
  doNotChangeURL: true,
  doNotChangeDomain: true,
  skipAffiliateHandling: false,
  rel: undefined,
  isMobile: false,
  isMspArticle: false,
  forceTargetBlank: false,
  isReviewsPage: false,
  target: '',
  commonState: {},
};

// export default React.forwardRef(Link);
const mapStateToProps = state => ({
  isMobile: state.isMobile,
  isReviewsPage: state.isTOIReviews,
  commonState: state.common,
});

const ConnectedLinkComponent = connect(mapStateToProps)(Link);
export default React.forwardRef((props, ref) => (
  <ConnectedLinkComponent innerRef={ref} {...props} />
));
